import React from 'react'
import AnnouncementIcon from '@mui/icons-material/Announcement'
import { Stack, Typography } from '@mui/material'
import { PatientInsiComparisonErrorProps } from './_props'
import sxs from './_sxs'

const PatientInsiComparisonError: React.FC<PatientInsiComparisonErrorProps> = ({
    icon = undefined,
    label = '',
    helperText = '',
}) => (
    <Stack flexDirection="row" alignItems="center" justifyContent="center" sx={sxs.patientInsiComparisonErrorContainer}>
        <Stack
            alignItems="center"
            justifyContent="center"
            gap="0.75rem"
            sx={sxs.patientInsiComparisonErrorInnerContainer}
        >
            {icon ?? <AnnouncementIcon sx={sxs.patientInsiComparisonErrorIcon} />}
            <Typography>{label}</Typography>
            <Typography>{helperText}</Typography>
        </Stack>
    </Stack>
)

export default PatientInsiComparisonError
